var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankCardUnknownLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1585.8 1086.6",
    style: {
      enableBackground: "new 0 0 1585.8 1086.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#34A853;}\n\t.st1{fill:#FFBB00;}\n\t.st2{fill:#FE2C25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#4285F4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rWN1jLPlw46ISWbh5Tmq1",
    transform: "matrix(1 0 0 1 0 -8.18)"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    className: "st0",
    d: "M1181.6,451.8H336.1V311.4c0-77.2,61.4-140.4,136.4-140.4h572.8 c75,0,136.4,63.2,136.4,140.4V451.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x35_JAGFK6vTcOBDWET5j7HA",
    transform: "matrix(1 0 0 1 0 -4.09)"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    className: "st1",
    d: "M1181.6,567H336.1V426.6c0-77.2,61.4-140.3,136.4-140.3h572.8 c75,0,136.4,63.1,136.4,140.3V567z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "O61mRXgZ76916z4p_sRXX",
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    className: "st2",
    d: "M1181.6,682.2H336.1V541.9c0-77.2,61.4-140.4,136.4-140.4h572.8 c75,0,136.4,63.2,136.4,140.4V682.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nK6POBbTEfGvlKBt_0cpt",
    transform: "matrix(1 0 0 1 0 5.3)"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    className: "st3",
    d: "M336.1,472l536.6,132c63.4,15.5,130.9,1.4,182.7-39.3l126.1-98.2v308.8 c0,77.2-61.4,140.4-136.4,140.4H472.4c-75,0-136.4-63.2-136.4-140.4V472z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCardUnknownLogo);
export default __webpack_public_path__ + "static/media/bank_card_unknown_logo.600aed6dcfa80b3ea922153097367994.svg";
export { ForwardRef as ReactComponent };